import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponse } from "../../../../../core/models";
import { BaseApiService } from "../../../../../core/services/base-api.service";
import type {
  DeactivatePaymentRequest,
  EmptyCartPaymentDetailDTO,
  ShoppingCartToCleanDTO,
} from "../../models/empty-cart.model";
import type { EmptyCartRepository } from "../contracts/empty-cart.repository";

@Injectable({
  providedIn: "root",
})
export class EmptyCartHttpRepository
  extends BaseApiService
  implements EmptyCartRepository
{
  /** POST /api/v1/EmptyCart/list (sin body) */
  public list(trafficNumber?: string): Observable<
    HttpResponse<ApiResponse<ShoppingCartToCleanDTO[]>>
  > {
    return this.http.post<ApiResponse<ShoppingCartToCleanDTO[]>>(
      `${this.baseUrl}/EmptyCart/list`,
      null,
      { observe: "response", params: trafficNumber?.trim() ? { trafficNumber: trafficNumber.trim() } : {} },
    );
  }

  public details(paymentId: string): Observable<HttpResponse<ApiResponse<EmptyCartPaymentDetailDTO>>> {
    return this.http.get<ApiResponse<EmptyCartPaymentDetailDTO>>(
      `${this.baseUrl}/EmptyCart/details/${encodeURIComponent(paymentId)}`,
      { observe: "response" },
    );
  }

  /** POST /api/v1/EmptyCart/deactivate */
  public deactivatePayment(
    request: DeactivatePaymentRequest,
  ): Observable<HttpResponse<ApiResponse<boolean>>> {
    return this.http.post<ApiResponse<boolean>>(
      `${this.baseUrl}/EmptyCart/deactivate`,
      request,
      { observe: "response" },
    );
  }
}
